import { createContext } from 'react';
import type { User, AuthState, LoginCredentials, RegisterData } from '@/types/Auth.types';

export interface AuthContextType extends AuthState {
  login: (credentials: LoginCredentials) => Promise<void>;
  setSession: (accessToken: string, refreshToken: string, user: User) => void;
  register: (data: RegisterData) => Promise<void>;
  logout: () => Promise<void>;
  updateUser: (user: User) => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);
